module.exports = "https://cdn.realtymogul.com/static/media/HP_card_1600golf.516351bd.jpg";